module.exports = __webpack_public_path__ + "img/size.ab212e7e.png";